import { IAppFeatures } from './interfaces';

export const appFeaturesSelectors = {
    getPartnerName: (state: IAppFeatures) => state.partnerName,

    isQuickBetEnabled: (state: IAppFeatures) => state.quickBetEnabled,

    isHtpOnScreenEnabled: (state: IAppFeatures) => state.htpOnScreenEnabled,

    isTutorialEnabled: (state: IAppFeatures) => state.tutorialEnabled,
};
